import { useEffect } from "react";
import { Controller } from "react-hook-form";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const ReturnFormLines = ({
  returnData,
  returnDataOriginal,
  control,
  setValue,
  watch,
  getValues,
}) => {
  const returnLines = returnData.data.data.returnOrderLines;
  const returnReasons = returnData.data.data.reasonCode;

  const returnLinesOriginal = returnDataOriginal.data.data.returnOrderLines;

  const validationHelper = {
    quantity: {
      required: "Quantity is required",
    },
    returnReason: { required: "Return reason is required" },
  };

  const isReturnable = (returnByDate) => {
    const now = dayjs();
    const returnDate = dayjs(returnByDate, "DD/MM/YY");
    if (now.isBefore(returnDate, "day")) {
      return true;
    }
  };

  // Set qtyOrdered form value to zero for non-returnable items
  useEffect(() => {
    returnLines.forEach((line, index) => {
      if (!isReturnable(line.returnByDate)) {
        setValue(`returnOrderLines[${index}].qtyOrdered`, 0);
      }
    });
  }, [returnLines, setValue]);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="Return Order Lines">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Product</TableCell>
            <TableCell>Colour</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Fit</TableCell>
            <TableCell>Returnable</TableCell>
            <TableCell>Return By Date</TableCell>
            <TableCell>Qty Ordered</TableCell>
            <TableCell>Qty to Return</TableCell>
            {/* <TableCell>Comment</TableCell> */}
            <TableCell>Reason</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {returnLines?.map((line, index) => {
            return (
              <TableRow
                key={line.lineNo}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {line.wearerName}
                </TableCell>
                <TableCell>{line.description}</TableCell>
                <TableCell>{line.colour}</TableCell>
                <TableCell>{line.size}</TableCell>
                <TableCell>{line.fit}</TableCell>
                <TableCell>
                  {isReturnable(line.returnByDate) ? (
                    <CheckCircleIcon color="success" />
                  ) : (
                    <CancelIcon color="disabled" />
                  )}
                </TableCell>
                <TableCell>
                  {dayjs(line.returnByDate, "DD/MM/YY").format("DD/MM/YY")}
                </TableCell>
                <TableCell>{returnLinesOriginal[index].qtyOrdered}</TableCell>
                <TableCell>
                  <Controller
                    // disabled={isReturnable(line.returnByDate) ? false : true}
                    name={`returnOrderLines[${index}].qtyOrdered`}
                    control={control}
                    rules={{
                      // required: isReturnable(line.returnByDate) ? true : false,
                      // min: isReturnable(line.returnByDate) ? 1 : 0,
                      min: 0,
                      max: isReturnable(line.returnByDate)
                        ? Number(returnLinesOriginal[index].qtyOrdered)
                        : 0,
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        size="small"
                        {...field}
                        type="number"
                        fullWidth
                        // label="Quantity"
                        error={error !== undefined}
                        helperText={
                          error ? validationHelper.quantity[error.type] : ""
                        }
                        slotProps={{
                          input: {
                            readOnly: isReturnable(line.returnByDate)
                              ? false
                              : true,
                          },

                          htmlInput: {
                            min: 0,
                            max: Number(returnLinesOriginal[index].qtyOrdered),
                          },
                        }}
                      />
                    )}
                  />
                </TableCell>

                <TableCell>
                  {returnReasons.length && (
                    <Controller
                      defaultValue=""
                      // disabled={isReturnable(line.returnByDate) ? false : true}

                      name={`returnOrderLines[${index}].returnReason`}
                      control={control}
                      rules={{
                        required:
                          Number(
                            watch(`returnOrderLines[${index}].qtyOrdered`),
                          ) === 0
                            ? false
                            : true,
                      }}
                      render={({ field, fieldState: { error } }) => {
                        const { value, ...newField } = field;
                        return (
                          <TextField
                            sx={{ minWidth: "200px" }}
                            size="small"
                            select
                            {...newField}
                            fullWidth
                            value={value || ""}
                            // label="Reason"
                            error={error !== undefined}
                            helperText={
                              error
                                ? validationHelper.returnReason[error.type]
                                : ""
                            }
                            slotProps={{
                              input: {
                                readOnly: isReturnable(line.returnByDate)
                                  ? false
                                  : true,
                              },
                            }}
                          >
                            <MenuItem disabled value="">
                              <em>Please select..</em>
                            </MenuItem>
                            {returnReasons?.map((reason) => (
                              <MenuItem value={reason.code} key={reason.code}>
                                {reason.description}
                              </MenuItem>
                            ))}
                          </TextField>
                        );
                      }}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
